{
  "sections_page": {
    "title": "Sections",
    "description": "TODO: Add description here!",
    "load_error": "We couldn't load this company's sections. Please try again.",
    "empty_state": {
      "title": "This company has no sections"
    },
    "headings": {
      "list": "TODO: List view heading",
      "tree": "TODO: Tree view heading"
    }
  },
  "section_form_page": {
    "create_title": "Create section",
    "edit_title": "Edit {name}",
    "description": "Group customers within a company and override the settings they inherit.",
    "details": {
      "title": "Details",
      "name_label": "Section name",
      "name_placeholder": "e.g. North region",
      "external_id_label": "Platform ID",
      "external_id_placeholder": "Identifier on your e-commerce platform",
      "integration_id_label": "Integration ID",
      "integration_id_placeholder": "Identifier in another integration",
      "accounting_id_label": "Accounting ID",
      "accounting_id_placeholder": "Identifier in your accounting system"
    },
    "context": {
      "title": "Settings",
      "description": "Settings applied to customers belonging to this section."
    },
    "delete_confirm_title": "Delete section",
    "delete_confirm_body": "Are you sure you want to delete {name}? This can't be undone."
  }
}
